import { escapeCurrencyDollars } from 'src/lib/markdownMath';

/**
 * Strip internal tutorial screenshot tags (e.g. `[screenshot 1]` or `[screenshot 1: Step description]`)
 * from markdown text so raw tool markers are never displayed to the user.
 *
 * Uses a negative lookbehind `(?<!!)` so markdown images without alt text
 * (`![screenshot 1](/tutorials/images/...)`) are preserved.
 */
export function stripTutorialScreenshotTags(markdown: string): string {
  if (!markdown) return '';
  return markdown.replace(/(?<!!)\[screenshot\s+\d[^\]]*\]/gi, '');
}

/**
 * Prepares raw chat markdown for display by stripping internal tool tags and escaping currency dollars.
 */
export function prepareChatMarkdown(markdown: string): string {
  if (!markdown) return '';
  const stripped = stripTutorialScreenshotTags(markdown);
  return escapeCurrencyDollars(stripped);
}
